import { AnimatePresence } from 'moti';
import React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import { Portal } from 'react-native-paper';

import { PopupArrow } from './popup-arrow';
import { PopupContainer } from './popup-container';
import { PopupInnerContainer } from './popup-inner-container';
import { PopupPosition } from './popup.types';
import { usePopup } from './use-popup';

export interface PopupProps {
  children: React.ReactNode;
  popupContent?: React.ReactNode;
  style?: StyleProp<ViewStyle>;
  arrowStyle?: StyleProp<ViewStyle>;
  arrowColor?: string;
  isVisible?: boolean;
  showArrow?: boolean;
  popupPosition?: PopupPosition;
  popupSpacing?: number;
}

const DEFAULT_SPACING = 8;

export const Popup: React.FC<PopupProps> = ({
  children,
  isVisible = false,
  popupContent,
  style,
  arrowStyle,
  arrowColor,
  popupPosition = 'bottom-center',
  showArrow = true,
  popupSpacing = DEFAULT_SPACING,
}) => {
  const childrenContainerRef = React.useRef<View>(null);

  const { childrenRect, finalPopupPosition } = usePopup({
    isVisible,
    popupPosition,
    popupSpacing,
    childrenContainerRef,
  });

  return (
    <>
      <Portal>
        <AnimatePresence>
          {isVisible && (
            <PopupContainer
              key="container"
              isVisible={isVisible}
              popupSpacing={popupSpacing}
              childrenRect={childrenRect}
              finalPopupPosition={finalPopupPosition}
            >
              <PopupInnerContainer
                style={style}
                key="inner-container"
                childrenRect={childrenRect}
                finalPopupPosition={finalPopupPosition}
              >
                {popupContent}
              </PopupInnerContainer>
              {showArrow && (
                <PopupArrow
                  key="arrow"
                  color={arrowColor}
                  style={arrowStyle}
                  width={childrenRect?.width}
                  popupPosition={finalPopupPosition}
                />
              )}
            </PopupContainer>
          )}
        </AnimatePresence>
      </Portal>
      <View collapsable={false} ref={childrenContainerRef}>
        {children}
      </View>
    </>
  );
};
